// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
    },
    selector: {
        products: '#product-loop'
    }
};

// Declare Templates
//alert('jagguu');
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<ul data-alpha="{{itemTitle}}" data-price="{{itemPriceLabel}}">   ' + '{{itemNewLabel}}' + '{{itemSaleLabel}}' + '{{itemSoldOutLabel}}' +
  								'<li class="devCompo devHiddenTitles">Composer</li><li class="devCompo">{{itemComp}}</li>' +
  								'<li class="devTitle devHiddenTitles">Title</li><li class="devTitle"><a href="{{itemUrl}}">{{itemTitle}}</a><br><span>{{itemAdditionalDetails}}</span></li>' +
  								'<li class="devInstr devHiddenTitles">Instrumentation</li><li class="devInstr">{{itemInstrumentation}}</li>' +
  								'<li class="devDurat devHiddenTitles">Duration</li><li class="devDurat">{{itemDuration}}<br><span>{{itemMovements}}</span></li>' + 
  								'<li class="devPubli devHiddenTitles">Publisher</li><li class="devPubli">{{itemPublisher}}</li>' +
  								'<li class="devPrice devHiddenTitles">Price</li><li class="devPrice">{{itemPriceLabel}}{{itemProductForm}}</li>' +
  								
                            '</ul>',

    // Pagination Template
    'previousHtml': '<a href="{{itemUrl}}" title=""><</a>',
    'nextHtml': '<a href="{{itemUrl}}" title="">></a>',
    'pageItemHtml': '<a href="{{itemUrl}}" title="">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<h4>' + bcSfFilterConfig.label.sorting + '</h4><select class="styled-select">{{sortingItems}}</select>',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  var x                      =0;
  var devCompTag             ='';
  var devComp                ='';
  var devCompName            ='';
  var devFirstComp           =''
  var devLastComp            =''
  var additionalTitle        ='';
  var devInstrumentation     ='';
  var devInstrumentationTemp     ='';
  var devDuration            ='';
  var movement01             ='';
  var movement02             ='';
  var movement03             ='';
  var movement04             ='';
  var movement05             ='';
  var movement06             ='';
  var movement07             ='';
  var movement08             ='';
  var movement09             ='';
  var movement10             ='';
  var devMoments             ='';
  var devPublisher           ='';
  var dummyProduct           = false;
  var devPrice               ='';
  var cartForm               ='';
  	
  	//console.log(data);
  
    for(x=0;x<data.tags.length;x++){
      
      if( data.tags[x].indexOf('AlternativeTitle_') >= 0 ){
        additionalTitle = data.tags[x].replace('AlternativeTitle_','').replace(/ ~/g, ', ');
      }
      
      if(data.tags[x].indexOf('bc_ComposerFullName_') > -1){
        devCompTag = data.tags[x];
      }
      
      if( data.tags[x].indexOf('S_') >= 0 ){
        devInstrumentationTemp = data.tags[x].replace('S_','').split('_');
      }
      if( data.tags[x].indexOf('DurationWhole_') >= 0 ){
        devDuration = data.tags[x].replace('DurationWhole_','').replace(/&/g, ', ');
      }
      if( data.tags[x].indexOf('movement01_duration') >= 0 ){
        movement01 = data.tags[x].replace('movement01_duration_','').replace(/&/g, ', ').replace(/~/g,',');
      }
      if( data.tags[x].indexOf('movement02_duration') >= 0 ){
        if( movement01.length > 0 ){
          movement02 = "+" + data.tags[x].replace('movement02_duration_','').replace(/&/g,', ').replace('~',',');
        } else {
          movement02 = data.tags[x].replace('movement02_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('movement03_duration') >= 0 ){
        if( movement01.length > 0 || movement02.length > 0 ){
          movement03 = "+" + data.tags[x].replace('movement03_duration_','').replace(/&/g,', ').replace(/~/g,',') + "<br>";
        } else {
          movement03 = data.tags[x].replace('movement03_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('movement04_duration') >= 0 ){
        if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 ){
          movement04 = "+" + data.tags[x].replace('movement04_duration_','').replace(/&/g,', ').replace('~',',');
        } else {
          movement04 = data.tags[x].replace('movement04_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('movement05_duration') >= 0 ){
        if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 ){
          movement05 = "+" + data.tags[x].replace('movement05_duration_','').replace(/&/g,', ').replace(/~/g,',');
        } else {
          movement05 = data.tags[x].replace('movement05_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('movement06_duration') >= 0 ){
        if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 || movement05.length > 0 ){
          movement06 = "+" + data.tags[x].replace('movement06_duration_','').replace(/&/g,', ').replace(/~/g,',')+ "<br>";
        } else {
          movement06 = data.tags[x].replace('movement06_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('movement07_duration') >= 0 ){
        if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 || movement05.length > 0 || movement06.length > 0 ){
          movement07 = "+" + data.tags[x].replace('movement07_duration_','').replace(/&/g,', ').replace(/~/g,',');
        } else {
          movement07 = data.tags[x].replace('movement07_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('movement08_duration') >= 0 ){
        if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 || movement05.length > 0 || movement06.length > 0 || movement07.length > 0 ){
          movement08 = "+" + data.tags[x].replace('movement08_duration_','').replace(/&/g,', ').replace(/~/g,',');
        } else {
          movement08 = data.tags[x].replace('movement08_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('movement09_duration') >= 0 ){
        if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 || movement05.length > 0 || movement06.length > 0 || movement07.length > 0 || movement08.length > 0 ){
          movement09 = "+" + data.tags[x].replace('movement09_duration_','').replace(/&/g,', ').replace(/~/g,',')+ "<br>";
        } else {
          movement09 = data.tags[x].replace('movement09_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('movement10_duration') >= 0 ){
        if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 || movement05.length > 0 || movement06.length > 0 || movement07.length > 0 || movement08.length > 0 || movement09.length > 0 ){
          movement10 = "+" + data.tags[x].replace('movement10_duration_','').replace(/&/g,', ').replace(/~/g,',');
        } else {
          movement10 = data.tags[x].replace('movement10_duration_','').replace(/&/g,', ').replace(/~/g,',');
        }
      }
      if( data.tags[x].indexOf('Publisher_') >= 0 ){
        devPublisher = data.tags[x].replace('Publisher_','');
      }
      if( data.tags[x].indexOf('Dummy_Yes') >= 0 ){
        dummyProduct = true;
      }
    }
  
    if(devCompTag.split('bc_ComposerFullName_').length > 1){
      devComp      = devCompTag.split('bc_ComposerFullName_')[1];
      devCompName  = devComp.split(',');
      devFirstComp = devCompName[1];
      devLastComp  = devCompName[0];
      if(devCompName.length > 1){
      	devCompName  = devFirstComp + ' ' + devLastComp;
      } else {
        devCompName  = devLastComp;
      }
    }
  	
  	devMoments = movement01 +""+ movement02 +""+ movement03 +""+ movement04 +""+ movement05 +""+ movement06 +""+ movement07 +""+ movement08 +""+ movement09 +""+ movement10;
  	
  	var bb = 0;
  	var devCHK=0;
    for( bb=0; bb < devInstrumentationTemp.length ; bb++){
      devCHK = bb+1;
      devInstrumentationTemp[bb] = devInstrumentationTemp[bb].replace(/~/g, ' ');
      if( devCHK == devInstrumentationTemp.length ){
      	devInstrumentation += devInstrumentationTemp[bb];
      } else {
        devInstrumentation += devInstrumentationTemp[bb] + ', ';
      }
    }
  	
  	if( dummyProduct == true ){
      devPrice = '';
      cartForm = '<a class="devMoreInfo" href="/products/' + data.handle + '">More Info</a>';
    } else {
      devPrice = Shopify.formatMoney(data.price_min);
      cartForm = '<form method="post" action="/cart/add"><input type="hidden" name="id" value="' + data.variants[0].id + '" /><input min="1" type="hidden" id="quantity" name="quantity" value="1"/><input type="submit" value="Add to cart" class="devListCart" /></form>';
    }  
  
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  
    // Add itemGridWidthClass
    var itemGridWidthClass = '';
    var productsPerRow = bcSfFilterConfig.custom.products_per_row;
    switch (productsPerRow) {
        case 4: itemGridWidthClass = buildItemGridClass('desktop-3', index, productsPerRow); break;
        case 3: itemGridWidthClass = buildItemGridClass('desktop-4', index, productsPerRow); break;
        default: break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add Label
    var itemNewLabelHtml = itemSaleLabelHtml = itemSoldOutLabelHtml = '';
    if (!soldOut) {
        if (data.collections) {
            var newLabel = data.collections.filter(function(e) { return e.handle == 'new'; });
            itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? '<div class="new">' + bcSfFilterConfig.label.new + '</div>' : '';
        }
        if (onSale) {
            itemSaleLabelHtml = '<div class="sale-item">' + bcSfFilterConfig.label.sale + '</div>';
        }
    } else {
        itemSoldOutLabelHtml = '<div class="so">' + bcSfFilterConfig.label.sold_out + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add Thumbnail
    var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '500x') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.show_vendor ? '<p>{{itemVendorLabel}}</p>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<div class="onsale">' + this.formatMoney(data.price_min, this.moneyFormat) + '</div>';
        itemPriceHtml += '<div class="was">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</div>';
    } else {
        itemPriceHtml += '<div class="prod-price">';
        if (priceVaries) {
            itemPriceHtml += bcSfFilterConfig.label.from_price + ' ' + this.formatMoney(data.price_min, this.moneyFormat) + ' - ' + this.formatMoney(data.price_max, this.moneyFormat);
        } else {
            itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        }
        itemPriceHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

     // Add variant
    var itemSwatchHtml = '';
    if (bcSfFilterConfig.custom.show_sizes && !soldOut) {
        var optionIndex = data.options_with_values.findIndex(function(e) { return e.name == 'size'; });
        var options = data.options_with_values.filter(function(e) { return (e.name).toLowerCase() == 'size'; });
        if (typeof options[0] !== 'undefined') {
            itemSwatchHtml += '<div class="size-swatch">';
            itemSwatchHtml += '<ul  data-option-index="' + optionIndex + '" class="' + options[0]['name'] + ' options">';
            var avaiVariants = [];
            for (var i = 0; i < data['variants'].length; i ++) {
                if (data['variants'][i].hasOwnProperty('option_size') && data['variants'][i]['available'] == true) {
                    var optionValue = data['variants'][i]['option_size'];
                    if (avaiVariants.indexOf(optionValue) == -1) {
                        avaiVariants[optionValue] = data['variants'][i];
                    }
                }
            }
            for (var k in avaiVariants) {
                var option = options[0]['values'].filter(function(e) { return e.title == avaiVariants[k]['option_size']; });
                var imageIndex = option[0]['image'];
                var variantImage = imageIndex !== null ? this.optimizeImage(data['images'][imageIndex]['src'], '500px') : bcSfFilterConfig.general.no_image_url;
                itemSwatchHtml += '<li data-option-title="' + avaiVariants[k]['option_size'] + '" data-href="' + variantImage + '" class="color ' + this.slugify(avaiVariants[k]['option_size']) + '">';
                itemSwatchHtml += '<a href="' + this.buildProductItemUrl(data) + '?variant=' + avaiVariants[k]['id'] + '">' + avaiVariants[k]['option_size'] + '</a>';
                itemSwatchHtml += '</li>';
            }
            itemSwatchHtml += '</ul></div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

    // Add main attribute
  	var devTitle = data.title.split("_")[1];
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, devTitle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemPriceLabel}}/g, devPrice);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  	itemHtml = itemHtml.replace(/{{itemComp}}/g, devCompName);
  	itemHtml = itemHtml.replace(/{{itemAdditionalDetails}}/g, additionalTitle);
  	itemHtml = itemHtml.replace(/{{itemInstrumentation}}/g, devInstrumentation);
  	itemHtml = itemHtml.replace(/{{itemDuration}}/g, devDuration);
  	itemHtml = itemHtml.replace(/{{itemMovements}}/g, devMoments);
  	itemHtml = itemHtml.replace(/{{itemPublisher}}/g, devPublisher);
  	itemHtml = itemHtml.replace(/{{itemProductForm}}/g, cartForm);

    return itemHtml;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

function buildItemGridClass(itemClass, index, productsPerRow) {
    var temp = index < productsPerRow ? index : index % productsPerRow;
    if (temp == 1) { itemClass += ' first'; }
    else if (temp == 0) { itemClass += ' last'; };
    return itemClass;
}

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;
        var breadcrumbHtml = '<a href="/" class="homepage-link" title="Back to the frontpage">' + bcSfFilterConfig.label.breadcrumb_home + '</a>';
        breadcrumbHtml += '<span class="separator">&raquo;</span>';
        if (bcSfFilterConfig.general.current_tags !== null) {
            var currentTags = bcSfFilterConfig.general.current_tags;
            breadcrumbHtml += ' <a href="/collections/' + colInfo.handle + '">' + colInfo.title + '</a>';
            breadcrumbHtml += ' <span class="separator">&raquo;</span>'
            breadcrumbHtml += ' <span class="page-title">' + currentTags[0] + '</span>';
        } else {
            breadcrumbHtml += ' <span class="page-title">' + colInfo.title + '</span>';
        }
        jQ('#breadcrumb').html(breadcrumbHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
    // Build number of products
    var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
    var to = from + data.products.length - 1;
    if( !(isNaN(to)) ){
      jQ('#pagination').find('.count').html(bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' ' +  bcSfFilterConfig.label.pagination_of + ' ' + data.total_product);
    }
};

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; } return data };

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
